/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFilteredPagination from "../Utils/useFilteredPagination";
import DataTable from "../Utils/DataTable";
import DeletePoPup from "./DeletePoPup";
import Pagination from "../Utils/Pagination";
import { useLocation, useParams, useNavigate } from "react-router-dom";

function CommonComponent({
	title,
	apiFunction,
	deleteFunction,
	dataMapper,
	columns,
	addButtonLabel,
	bookingOnOff,
	contentName,
	urlName,
	AddComponent,
	itemsPerPage,
	currentPageNo = 1,
	showActionButtons,
	showSettingButton,
	apiFunctionForDeleteUndo,
	hideDeleteActionsButtons,
	showPageDetails,
	deleteMultipleFunction,
	showstatusToggel,
	showTableTitle,
	refresh, 
	enableDragAndDrop,
	searchValue = '',
	triggerSearch,
	searchStartDate,
	searchEndDate,
	updateInSamePage = false,
	updateFunction = '',
	showDeleteBtn = true,
	showUpdatePopup=false,
	type="",
	// selection props (optional)
	selectedItems = [],
	onSelectAll = null,
	selectionEnabled = false,
}) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const data = useSelector((state) => state.data);
	const [currentAction, setCurrentAction] = useState("all");
	const [loading, setLoading] = useState(true);
	const [Actions, setActions] = useState({});
	const [toggleMenu, setToggleMenu] = useState(false);
	const [ItemId, setItemId] = useState({});
	const [Open, setOpen] = useState(false);
	const [DeleteOpen, setDeleteOpen] = useState(false);
	const [totalPages, setTotalPages] = useState(1);
	const [totalCount, setTotalCount] = useState(1);
	const [currentPage, setCurrentPage] = useState(parseInt(currentPageNo));
	const [newItemPerPage, setNewItemPerPage] = useState(itemsPerPage);
	const { ID } = useParams();
	const actionButtons = ["all", "active", "inactive", "deleted"];
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const startDate = (searchStartDate)?searchStartDate:searchParams.get("startDate");
	const endDate = (searchEndDate)?searchEndDate:searchParams.get("endDate");
	const [MoveRefundOpen, setMoveRefundOpen] = useState(false);
	const handleActionClick = (action) => {
		setCurrentAction(action);
	};

	useEffect(() => {
		setCurrentPage(currentPageNo);
		setNewItemPerPage(itemsPerPage);
	}, [currentPageNo, itemsPerPage]);
	const handleCurrentPageChange = (pageNo) => {
		const params = new URLSearchParams(location.search);
		params.set("page", pageNo);
		navigate(`${location.pathname}?${params.toString()}`);
		setCurrentPage(pageNo);
	};

	const {
		filters,
		handleFilterChange,
		handlePageChange,
		displayedData,
		totalData,
		toggleActions,
		handelFindDataByID,
	} = useFilteredPagination(
		data[contentName],
		setActions,
		setItemId,
		setOpen,
		setDeleteOpen,
		currentPage,
		setMoveRefundOpen,
		handleCurrentPageChange,
		setToggleMenu
	);

	const handleDeleteItem = () => {
		dispatch(deleteFunction(ItemId?._id, setDeleteOpen, DeleteOpen));
	};

	const dataMappers = dataMapper(ItemId);
	useMemo(() => {
		setLoading(true);
		let updatedFilters;
		if(searchValue){
			updatedFilters = {
				combinedFilter: searchValue,
			};
		}
		else{
			updatedFilters = {
				...filters
			};
		}
		dispatch(
			apiFunction(
				currentPage,
				newItemPerPage,
				updatedFilters,
				setTotalPages,
				setTotalCount,
				ID,
				currentAction,
				startDate,
				endDate,
				type
			)
		).then(() => {
			setLoading(false);
		});
	}, [
		dispatch,
		apiFunction,
		newItemPerPage,
		contentName,
		currentPage,
		filters,
		ID,
		currentAction,
		startDate,
		endDate,
		refresh,
		triggerSearch,
		type
	]);
	const handleItemsPerPageChange = (newItemsPerPage) => {
		setNewItemPerPage(newItemsPerPage);
		const params = new URLSearchParams(location.search);
		params.set("perPage", newItemsPerPage);
		params.set("page", 1);
		navigate(`${location.pathname}?${params.toString()}`);
		setCurrentPage(1);
	};
	return (
		<div className="rounded-3xl bg-white pb-5 max-h-full w-full max-w-full">
			{toggleMenu && (
				<AddComponent setToggleMenu={setToggleMenu} toggleMenu={toggleMenu} />
			)}
			{Open && (
				<AddComponent
					setToggleMenu={setOpen}
					toggleMenu={Open}
					data={dataMappers}
				/>
			)}
			<DataTable
				displayedData={displayedData}
				selectedItems={selectedItems}
				onSelectAll={onSelectAll}
				selectionEnabled={selectionEnabled}
				toggleActions={toggleActions}
				Actions={Actions}
				handelFindDataByID={handelFindDataByID}
				columns={columns}
				contentName={contentName}
				urlName={urlName}
				addButtonLabel={addButtonLabel}
				bookingOnOff={bookingOnOff}
				setToggleMenu={(val) => {
					setToggleMenu(val);
					if (val) setOpen(false);
				}}
				toggleMenu={toggleMenu}
				filters={filters}
				handleFilterChange={handleFilterChange}
				totalData={totalData}
				title={title}
				loading={loading}
				apiFunctionForDeleteUndo={apiFunctionForDeleteUndo}
				deleteMultipleFunction={deleteMultipleFunction}
				showPageDetails={showPageDetails}
				showUpdatePopup={showUpdatePopup}
				currentAction={currentAction}
				showstatusToggel={showstatusToggel}
				showTableTitle={showTableTitle}
				showSettingButton={showSettingButton}
				enableDragAndDrop={enableDragAndDrop}
				showActionButtons={showActionButtons}
				updateInSamePage={updateInSamePage}
				updateFunction={updateFunction}
				showDeleteBtn={showDeleteBtn}
			/>
			{itemsPerPage !== 0 && (
				<Pagination
					currentPage={currentPage}
					totalPages={totalPages}
					onPageChange={handlePageChange}
					pageSize={newItemPerPage}
					totalEntries={totalCount}
					onItemsPerPageChange={handleItemsPerPageChange}
				/>
			)}

			{DeleteOpen && (
				<DeletePoPup
					setIsDelteClientOpen={setDeleteOpen}
					isDelteClientOpen={DeleteOpen}
					handleDelete={handleDeleteItem}
					content={title}
				/>
			)}
		</div>
	);
}

export default CommonComponent;
